export const UPDATE_ENTITY_STATE = 'UPDATE_ENTITY_STATE'
export const ENTITY_CREATED = 'ENTITY_CREATED'
export const ENTITY_DELETED = 'ENTITY_DELETED'
export const ENTITY_UPDATED = 'ENTITY_UPDATED'
